import React from "react";
import { CtaButton } from "./CtaButton";
import { projectCategories } from "../data/content";
export function ProjectCategories() {
  return <section className="bg-peach px-4 py-14" aria-labelledby="categories-title" data-id="element-128" data-mp="2626t3xbaetgx">
      <div className="mx-auto max-w-5xl" data-id="element-129" data-mp="2b45uj1ngvgb8">
        <p className="text-center font-heading text-sm font-bold uppercase text-brand" data-id="element-130" data-mp="2b11k3mjeroc4">A plan for every occasion</p>
        <h2 id="categories-title" className="mx-auto mt-2 max-w-3xl text-center font-heading text-xl font-bold uppercase leading-snug md:text-2xl" data-id="element-131" data-mp="1iegrkir7566z">
          From quick weekend builds to heirloom pieces, your next project is waiting here
        </h2>
        <div className="mt-12 space-y-12" data-id="element-132" data-mp="1sas85kxtki78">
          {projectCategories.map((c, i) => <article key={c.title} className="grid items-center gap-8 md:grid-cols-2" data-id="element-133" data-mp="1x44tnm77c8vr" data-mpi={i}>
              <div className={i % 2 === 1 ? "md:order-2" : ""} data-id="element-134" data-mp="zoh7696awf9w">
                <h3 className="font-heading text-xl font-bold uppercase" data-id="element-135" data-mp="zluy253rhrpk">
                  <span className="text-brand" data-id="element-136" data-mp="14kxw35lbqxo1">{i + 1}.</span> {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-137" data-mp="y6g1dhpqnlsd">{c.text}</p>
                <a href="#offer" className="mt-4 inline-block text-sm font-bold text-brand underline-offset-4 hover:underline" data-id="element-138" data-mp="t95zh2l5xhnn">
                  See included projects →
                </a>
              </div>
              <img src={c.image} alt={c.title} className={`aspect-[4/3] w-full rounded-lg object-cover shadow-sm ${i % 2 === 1 ? "md:order-1" : ""}`} data-id="element-139" data-mp="kf1e2yossyfi" />
            </article>)}
        </div>
        <div className="mt-12" data-id="element-140" data-mp="aglmyvprtp60">
          <CtaButton label="Start building today" data-id="element-141" data-mp="ajg9qtw9bm2l" />
        </div>
      </div>
    </section>;
}